import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { PageFn } from '.';
import { T } from '../../Translations';
import clsx from 'clsx';

interface Props {
  metadata: PaginationMetadata;
  pageFn: PageFn;
}

const Next: React.FC<Props> = ({ metadata, pageFn }) => {
  return (
    <a
      onClick={() => pageFn(metadata.currentPage + 1)}
      className={clsx('cursor-pointer relative inline-flex items-center px-2 py-2 text-teal-600')}
    >
      <T kind="Next" />
      <div className="pl-2">
        <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
      </div>
    </a>
  );
};

export default observer(Next);
